import { objectHelper } from "@/_shared/utils";

const adaptProviderProducts = (values = {}) => {
  if (values.adding.length < 1 && values.removing.length < 1) {
    return null;
  };
  values = objectHelper.createCopy(values);
  const results = { adding: [], removing: [] };
  results.adding = values.adding.map((value) => ({
    [value.entityKey]: value.id,
    price: value.price,
  }));
  results.removing = values.removing.map(({ id }) => id);
  return results;
};

const requestAdapter = {
  adaptProviderProducts,
};

export default requestAdapter;



// WEBPACK FOOTER //
// ./src/business/api-services/_requestAdapter.js